<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>添加专题</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :model="topicForm" ref="topicForm" :rules="addTopicRules">
            <el-form-item label="专题标题" label-width="150px" prop="title">
                <el-input v-model="topicForm.title"></el-input>
            </el-form-item>
            <el-form-item label="专题描述" label-width="150px" prop="caption">
                <el-input v-model="topicForm.caption"></el-input>
            </el-form-item>
            <el-form-item label="上传banner图" label-width="150px" prop="banner">
                <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :on-error="handleError" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="uptoken">
                    <img v-if="topicForm.banner" :src="topicForm.banner" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="跳转类型选择" label-width="150px" prop="topicType">
                <el-radio-group v-model="topicForm.topicType" @change="typeChange">
                    <el-radio label='0'>商品分类</el-radio>
                    <el-radio label='1'>商品标签</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="已选择" label-width="150px" v-if="topicForm.topicType">
                <el-input v-model="choosedNow" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="专题下的商品选择" label-width="150px">
                <el-select v-model="topicForm.shop" placeholder="商品" @change="productChoose">
                    <el-option v-for="item in productArr" :key="item.productDetailId" :label="item.name" v-if="item.isOnline" :value="item.productDetailId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="当前租金(元)" label-width="150px" v-if="topicForm.product">
                <el-input v-model="topicForm.product.rental" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="商品原价(元)" label-width="150px" prop="oldRental" v-if="topicForm.product">
                <el-input v-model="topicForm.product.oldRental"></el-input>
            </el-form-item>
            <el-form-item label="专题二维码尺寸" label-width="150px">
                <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :on-error="handleError" :show-file-list="false" :on-success="handlePicArrSuccess" :before-upload="beforeAvatarUpload" :data="uptoken">
                    <img v-if="topicUrl" :src="topicUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button type="success" @click="addProduct">添加该商品</el-button>
            </el-form-item>
            <el-form-item label="已选择商品" label-width="150px" v-if="topicForm.productDetails.length">
                <el-row>
                    <el-col :span="8" v-for="(o, index) in topicForm.productDetails" :key="index" :offset="index > 0 ? 2 : 0">
                        <el-card :body-style="{ padding: '0px' }">
                            <img v-if="o.qrcode" :src="o.qrcode" class="image">
                            <div style="padding: 14px;">
                                <span>{{o.name}}</span>
                                <div class="bottom clearfix">
                                    <el-button type="danger" @click="remove(index)">删除</el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-form-item>
    
            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    
        <el-dialog title="选择标签" v-model="chooseTopic">
            <el-form :model="cur_topic">
                <el-form-item label="选择标签" label-width="100px">
                    <el-select v-model="cur_topic.now" placeholder="标签">
                        <el-option v-for="item in topicArr" v-if="item.isOnline" :key="item.tagId" :label="item.name" :value="item.tagId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseTopic = false">取 消</el-button>
                <el-button type="primary" @click="topicChoose">确 定</el-button>
            </div>
        </el-dialog>
    
        <el-dialog title="选择分类" v-model="chooseCatogry">
            <el-form :model="cur_categroy">
                <el-form-item label="选择分类" label-width="100px">
                    <el-select v-model="cur_categroy.now" placeholder="分类">
                        <el-option v-for="item in categoryArr" v-if="item.isOnline" :key="item.categoryId" :label="item.name" :value="item.categoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseCatogry = false">取 消</el-button>
                <el-button type="primary" @click="catogryChoose">确 定</el-button>
            </div>
        </el-dialog>
    
    </div>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        filterIndexVersions,
        getProductCategories,
        getProductTags,
        getProductDetails,
        getProductDetailsOnly
    } from '../../api/version'
    
    export default {
        data() {
            return {
                topicForm: {
                    targetId: '',
                    title: '',
                    caption: '',
                    topicType: '',
                    shop: '',
                    banner: '',
                    product: '',
                    productDetails: []
                },
                topicUrl: '',
                choosedNow: '',
                fileList2: [],
                upImage: '',
                type: '',
                targetId: '',
                uptoken: {
                    token: sessionStorage.token
                },
                productArr: [],
                picArr: [],
                topicArr: [],
                categoryArr: [],
                chooseCatogry: false,
                chooseTopic: false,
                cur_categroy: {
                    now: ''
                },
                cur_topic: {
                    now: ''
                },
                addTopicRules: {
                    title: [{
                        required: true,
                        message: '请输入专题标题',
                        trigger: 'blur'
                    }],
                    caption: [{
                        required: true,
                        message: '请输入专题描述',
                        trigger: 'blur'
                    }],
                    banner: [{
                        required: true,
                        message: '请上传专题banner图',
                        trigger: 'blur'
                    }],
                    shop: [{
                        type: 'number',
                        required: true,
                        message: '请选择专题下的商品',
                        trigger: 'blur'
                    }],
                    topicType: [{
                        required: true,
                        message: '请选择跳转类型',
                        trigger: 'blur'
                    }]
                },
            }
        },
        created() {
            getProductDetailsOnly(sessionStorage.userId,JSON.stringify({where:{accessoryType: 0}})).then(res => {
                this.productArr = res.data
                console.log(res.data)
                this.$store.commit('SETTOPICARR', this.productArr);
            })
            getProductCategories().then(res => {
                this.categoryArr = res.data
                this.$store.commit('SETCATEGORYARR', this.categoryArr);
            })
    
            getProductTags().then(res => {
                this.topicArr = res.data
                this.$store.commit('SETPRODUCTARR', this.topicArr);
            })
        },
        methods: {
            // 删除已选中的商品
            remove(index) {
                this.topicForm.productDetails.splice(index, 1)
            },
            goBack() {
                //取消
                this.$router.push('/indexTopic')
            },
            addProduct() {
                let current_product = this.topicForm.product
                console.log(current_product)
    
                if (current_product && this.topicUrl) {
                    this.topicForm.productDetails.push({
                        picUrl: current_product.media ? current_product.media.pic[0] : null,
                        qrcode: this.topicUrl,
                        name: current_product.name,
                        productDetailId: current_product.productDetailId,
                        price_old: current_product.oldRental,
                        price_current: current_product.rental
                    })
                    this.topicUrl = ''
                    this.topicForm.product = ''
                    this.topicForm.shop = ''
                } else if (!current_product) {
                    this.$message.error('请先选择商品');
                } else if (!this.topicUrl) {
                    this.$message.error('请上传商品二维码尺寸')
                }
            },
            typeChange(val) {
                // banner的类型	0:分类，1:标签, 2:商品
                this.topicForm.topicType = val
                if (val === '0') {
                    this.chooseCatogry = true
                } else {
                    this.chooseTopic = true
                }
            },
            productChoose(val) {
                this.productArr.forEach( item => {
                    if(item.productDetailId === val) {
                        this.topicForm.product = item
                    }
                })
                
            },
            topicChoose() {
                this.topicForm.targetId = this.cur_topic.now
                this.chooseTopic = false
                this.topicArr.forEach(item => {
                    if (item.tagId === this.topicForm.targetId) {
                        this.choosedNow = item.name
                    }
                })
            },
            catogryChoose() {
                this.topicForm.targetId = this.cur_categroy.now
                this.chooseCatogry = false
                this.categoryArr.forEach(item => {
                    if (item.categoryId === this.topicForm.targetId) {
                        this.choosedNow = item.name
                    }
                })
            },
            onSubmit() {
                console.log(this.topicForm)
                this.$refs['topicForm'].validate((valid) => {
                    if (valid) {
                        if (!this.topicForm.productDetails.length) {
                            this.$message.error('请先添加商品!');
                        } else {
                            let currentData = this.$store.state.currentIndex
                            let current = JSON.parse(JSON.stringify(this.topicForm))
                            delete current.shop
                            delete current.product
                            current.topicType = current.topicType * 1
                            currentData.value.topic.push(current)
                            this.$store.commit('SETCURRENTINDEX', currentData);
                            this.$router.push('/indexTopic')
                        }
    
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
    
            handleAvatarSuccess(res, file) {
                this.topicForm.banner = `https://img.shareplay.cc/${res.key}`
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            handlePicArrSuccess(res, file) {
                this.topicUrl = `https://img.shareplay.cc/${res.key}`
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                this.uptoken = {
                    token: sessionStorage.token
                }
    
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleRemove(file, fileList) {
                this.fileList2 = fileList
            },
            handlePreview(file) {
                console.log(file);
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            }
        }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .el-upload-list {
        display: flex;
    }
    
    .el-upload-list--picture .el-upload-list__item {
        width: 300px;
        margin-right: 15px;
    }
    
    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }
    
    .button {
        padding: 0;
        float: right;
    }
    
    .image {
        width: 100%;
        display: block;
    }
    
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }
</style>




// WEBPACK FOOTER //
// AddTopic.vue?776bc718